// import {
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Grid,
//   IconButton,
//   Snackbar,
// } from '@mui/material';
// import React, { useState, useEffect, useRef } from 'react';
// import { useMain } from '../hooks/useMain';
// import TextInputs from 'src/components/inputs/TextInputs';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useNavigate } from 'react-router';
// import { AiOutlineInfoCircle } from "react-icons/ai";
// import { MdDelete } from "react-icons/md";
// import { FaRegEdit } from "react-icons/fa";
// import { FaEye } from "react-icons/fa";
// import { QurealCollection, useQurealActions } from "qureal-editor";
// import {
//   setLoading,
//   setUpdatedServiceMembershipData,
//   addServiceRow,
//   removeServiceRow,
//   updateServiceRow,
//   setSelectedServiceMembership,
//   resetUpdatedServiceMembershipData,
//   removeMembershipFromState,
//   updateMembershipInState
// } from '../../redux/slices/membershipSlice';
// import { useDispatch, useSelector } from 'react-redux';
// import { IoStar } from 'react-icons/io5';
// import MembershipServiceSuggestion from "./MembershipServiceSuggestion";

// export const TrimData = (data) => {
//   if (data?.length < 25) return data;
//   return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
// };

// const ServiceTypeFieldData = ({ data, state, branchData, services }) => {
//   const dispatch = useDispatch();
//   const {
//     updatedMembershipData,
//     selectedMembershipId,
//     loading
//   } = useSelector((state) => state.memberships);

//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [openEyeDialog, setOpenEyeDialog] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [selectedCardItem, setSelectedCardItem] = useState({});
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const { actionRef, download, share } = useQurealActions();
//   const [serviceSuggested, setServiceSuggested] = useState([]);
//   const [focusedServiceIndex, setFocusedServiceIndex] = useState(null);
//   const [focusedInputs, setFocusedInputs] = useState({});
//   const inputRefs = useRef([]);

//   const navigate = useNavigate();
//   const { deleteMembership, activeBranchId, updateMembership, setShowMessage } = useMain();

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//     dispatch(resetUpdatedServiceMembershipData());
//     setServiceSuggested([]);
//     setFocusedServiceIndex(null);
//     setFocusedInputs({});
//   };

//   const handleUpdate = (item) => {
//     dispatch(setSelectedServiceMembership(item));
//     setOpenDialogue(true);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(setUpdatedServiceMembershipData({ field: name, value }));
//   };

//   const handleServiceChange = (e, index) => {
//     const { name, value } = e.target;

//     // For availableCount field, handle empty string case
//     let newValue = value;
//     if (name === 'availableCount') {
//       newValue = value === '' ? '' : Number(value);
//     }
//     dispatch(updateServiceRow({ index, field: name, value: newValue }));
//   };

//   const handleAddServiceRow = () => {
//     dispatch(addServiceRow());
//   };

//   const handleRemoveServiceRow = (index) => {
//     dispatch(removeServiceRow(index));
//   };

//   const handleUpdateServiceTypeMembership = async () => {
//     try {
//       dispatch(setLoading(true));
      
//       // Validate that all services have been selected
//       const hasEmptyService = updatedMembershipData.servicesOffered.some(
//         item => !item.service || item.service === ''
//       );
      
//       if (hasEmptyService) {
//         setShowMessage({
//           message: 'Please select a service for all rows',
//           messageType: 'error'
//         });
//         return;
//       }

//       const preparedData = {
//         ...updatedMembershipData,
//         servicesOffered: updatedMembershipData.servicesOffered.map(service => ({
//           service: service.service,
//           availableCount: service.availableCount === '' ? 0 : service.availableCount
//         }))
//       };

//       const res = await updateMembership(
//         selectedMembershipId,
//         preparedData,
//         `?branchId=${activeBranchId}`
//       );

//       if (res.statusCode === 200) {
//         setShowMessage({
//           message: res.message || "Membership updated successfully",
//           messageType: 'success'
//         });

//         // Update Redux state directly instead of refetching
//         dispatch(updateMembershipInState({
//           _id: selectedMembershipId,
//           ...updatedMembershipData,
//           membershipType: 'serviceType'
//         }));

//         handleCloseDialogue();
//       } else {
//         setShowMessage({
//           message: res.message || 'Update Membership failed',
//           messageType: 'error'
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error'
//       });
//     } finally {
//       dispatch(setLoading(false));
//     }
//   };

//   const handleDetails = (id) => {
//     navigate(`/membershipdetail/${id}`, { state });
//   };

//   const handleEyeClick = (item) => {
//     setSelectedCardItem(item);
//     setOpenEyeDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenEyeDialog(false);
//   };

//   const handleDeleteField = (id) => {
//     setDeleteId(id);
//     setOpenDeleteDialog(true);
//   };

//   const confirmDelete = async () => {
//     setDeleteLoading(true);
//     try {
//       const res = await deleteMembership(deleteId, `?branchId=${activeBranchId}`);
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Membership deleted successfully',
//           messageType: 'success',
//         });

//         dispatch(removeMembershipFromState(deleteId));
//       } else {
//         setShowMessage({
//           message: res.message || 'Membership not deleted',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setOpenDeleteDialog(false);
//       setDeleteId(null);
//       setDeleteLoading(false);
//     }
//   };

//   const handleCloseDeleteDialog = () => {
//     setOpenDeleteDialog(false);
//     setDeleteId(null);
//   };

//   // Function to get service name by ID
//   const getServiceNameById = (serviceId) => {
//     const service = services.find(s => s._id === serviceId);
//     return service ? service.serviceName : 'Unknown Service';
//   };

//   // Function to build content dynamically
//   const buildContent = (services) => {
//     return services?.map(serviceObj => {
//       const serviceName = getServiceNameById(serviceObj.service?._id);
//       return `✶ ${serviceName} (${serviceObj.availableCount} counts)`;
//     }).join('<br>');
//   };

//   // Service input change handler
//   const handleServiceInputChange = (e, index) => {
//     const { value } = e.target;
    
//     // Update the service name in Redux state
//     dispatch(updateServiceRow({ index, field: 'serviceName', value: value }));
//     dispatch(updateServiceRow({ index, field: 'service', value: '' }));
    
//     updateServiceSuggested(value, index);
//     setFocusedServiceIndex(index);
//   };

//   const updateServiceSuggested = (inputValue, index) => {
//     if (inputValue === '') {
//       setServiceSuggested([]);
//       setFocusedServiceIndex(null);
//     } else {
//       const serviceSuggestions = services?.filter((service) =>
//         service.serviceName.toLowerCase().includes(inputValue.toLowerCase())
//       );
//       setServiceSuggested(serviceSuggestions || []);
//       setFocusedServiceIndex(index);
//     }
//   };

//   const handleServiceSuggestedClick = (service) => {
//     const index = focusedServiceIndex;
//     if (index !== null) {
//       // Update the service in Redux state
//       dispatch(updateServiceRow({ index, field: 'service', value: service._id }));
//       dispatch(updateServiceRow({ index, field: 'serviceName', value: service.serviceName }));
//       setServiceSuggested([]);
//       setFocusedServiceIndex(null);
      
//       // Focus on the next input field (availableCount)
//       setTimeout(() => {
//         if (inputRefs.current[index] && inputRefs.current[index].availableCountInput) {
//           inputRefs.current[index].availableCountInput.focus();
//         }
//       }, 100);
//     }
//   };

//   const handleInputFocus = (index, fieldName) => {
//     setFocusedInputs(prev => ({ ...prev, [index]: fieldName }));
//   };

//   const handleInputBlur = (index, fieldName) => {
//     setFocusedInputs(prev => {
//       const newState = { ...prev };
//       delete newState[index];
//       return newState;
//     });
//   };

//   // Get display value for service input
//   const getServiceDisplayValue = (item) => {
//     return item.serviceName || (item.service ? getServiceNameById(item.service) : '');
//   };

//   console.log(selectedCardItem,'selectedcard')

//   return (
//     <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
//       <Snackbar
//         open={errorMessage === '' ? false : true}
//         autoHideDuration={6000}
//         onClose={() => {
//           setErrorMessage('');
//         }}
//         severity="error"
//         message={errorMessage}
//         anchorOrigin={{
//           vertical: 'top',
//           horizontal: 'right',
//         }}
//       />
//       <table className="table-container mt-3">
//         <thead className="table-thead">
//           <tr>
//             {[
//               'Membership Name',
//               'Membership Price',
//               'Validity',
//               'Rewards Points',
//               'Actions',
//             ].map((h, index) => {
//               return <th key={index} style={{ width: '100%' }}>{h}</th>;
//             })}
//           </tr>
//         </thead>
//         <tbody className="table-tbody">
//           {data.map((item) => {
//             return (
//               <tr key={item._id}>
//                 <td style={{ width: '100%' }}>{TrimData(item?.membershipName)}</td>
//                 <td style={{ width: '100%' }}>{item?.membershipPrice}</td>
//                 <td style={{ width: '100%' }}>{item?.duration}</td>
//                 <td style={{ width: '100%' }}>{item?.rewardPointsOnPurchase}</td>
//                 <td style={{
//                   width: '100%',
//                   marginLeft: '-5.2rem',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   marginRight: '5rem'
//                 }}>
//                   <IconButton onClick={() => handleDetails(item._id)} color="primary" title="View Details" style={{ marginRight: '-5px' }}>
//                     <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem', marginLeft: '1.5rem' }} />
//                   </IconButton>
//                   <IconButton onClick={() => handleUpdate(item)} color="secondary" title="Update" style={{ marginRight: '24px' }}>
//                     <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
//                   </IconButton>
//                   <IconButton onClick={() => handleDeleteField(item._id)} color="error" title="Delete" style={{ marginLeft: '-33px' }}>
//                     <MdDelete color='#FF4D4D' style={{ fontSize: '1.2rem', marginTop: '1px' }} />
//                   </IconButton>
//                   <IconButton onClick={() => handleEyeClick(item)} color="primary" title="View">
//                     <FaEye color="black" style={{ fontSize: '1.2rem', marginTop: '1px', marginLeft: '20px' }} />
//                   </IconButton>
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>

//       {/* Card-Membership Dialog */}
//       <Dialog
//         open={openEyeDialog}
//         onClose={handleCloseDialog}
//         maxWidth={false}
//         PaperProps={{
//           style: {
//             width: "1100px",
//             height: "100vh",
//             margin: "auto",
//             display: "flex",
//             flexDirection: "column",
//             borderRadius: "10px",
//             padding: "10px",
//           },
//         }}  
//       >
//         <DialogContent
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             flexGrow: 1,
//             padding: "0",
//             backgroundColor: "white",
//             overflow: "hidden",
//           }}
//         >
//           <QurealCollection
//             collection_id="9ff9f448-3ce3-4d09-9bcc-4e5c4d763a9a"
//             organization="your_salon_QBdXA"
//             background="white"
//             style={{
//               width: "100%",
//               height: "100%",
//               border: "1px solid black",
//               borderRadius: "10px",
//               overflow: "hidden",
//             }}
//             actionRef={actionRef}
//             preview={true}
//             prefill={{
//               discount_offer_with_body: {
//                 offer_name: selectedCardItem.membershipName,
//                 offer_price: `RS${selectedCardItem.membershipPrice}`,
//                 validity: `Valid for ${selectedCardItem.duration} Months `,
//                 content: buildContent(selectedCardItem?.servicesOffered),
//                 extra: "",
//               },
//               ai_model: {
//                 model: "e9c8b5c4-4a2f-4c15-85a4-a57669a00999",
//               },
//               current_organization: {
//                 name: branchData?.branchName,
//                 primary_phone: branchData?.branchPhone,
//                 primary_email: branchData?.branchEmail,
//                 address: branchData?.address,
//                 website: branchData?.branchName,
//                 logo: {
//                   value: branchData?.logo?.url,
//                 },
//                 logo_dark: {
//                   value: branchData?.logo?.url,
//                 },
//                 logo_square: {
//                   value: branchData?.logo?.url,
//                 }
//               }
//             }}
//           />
//         </DialogContent>

//         <DialogActions
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             padding: "16px",
//             backgroundColor: "#f5f5f5",
//           }}
//         >
//           <Button
//             onClick={handleCloseDialog}
//             color="primary"
//             style={{
//               marginRight: "10px",
//             }}
//           >
//             Close
//           </Button>

//           <Button
//             variant="contained"
//             color="primary"
//             sx={{
//               background: '#6174DD',
//               marginRight: "10px",
//             }}
//             onClick={share}
//           >
//             Share
//           </Button>

//           <Button
//             variant="contained"
//             color="primary"
//             sx={{
//               background: '#6174DD',
//             }}
//             onClick={download}
//           >
//             Download
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
//         <DialogContent>
//           Are you sure you want to delete this Membership?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
//           <Button onClick={confirmDelete} color="secondary">Delete</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ServiceType membership details dialog */}
//       <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md" fullWidth>
//         <DialogTitle>ServiceType Membership Details</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Here you can update membership details.</DialogContentText>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={4}>
//               <Grid item xs={12} md={3}>
//                 <TextInputs
//                   title={'Membership Name'}
//                   name={'membershipName'}
//                   value={updatedMembershipData?.membershipName}
//                   handleChange={handleInputChange}
//                   type={'text'}
//                 />
//               </Grid>
//               <Grid item xs={12} md={3}>
//                 <TextInputs
//                   title={'Duration (in Months)'}
//                   name={'duration'}
//                   value={updatedMembershipData?.duration}
//                   handleChange={handleInputChange}
//                   type={'number'}
//                 />
//               </Grid>
//               <Grid item xs={12} md={3}>
//                 <TextInputs
//                   title={'Membership Price'}
//                   name={'membershipPrice'}
//                   value={updatedMembershipData?.membershipPrice}
//                   handleChange={handleInputChange}
//                   type={'number'}
//                 />
//               </Grid>
//               <Grid item xs={12} md={3}>
//                 <TextInputs
//                   title={'Reward Points'}
//                   name={'rewardPointsOnPurchase'}
//                   value={updatedMembershipData?.rewardPointsOnPurchase}
//                   handleChange={handleInputChange}
//                   type={'number'}
//                 />
//               </Grid>
//             </Grid>
//           </Box>

//           {updatedMembershipData.servicesOffered.map((item, index) => (
//             <Box style={{ marginTop: '20px', position: 'relative' }} key={index}>
//               <Grid container spacing={4} alignItems="center">
//                 <Grid item xs={12} md={4}>
//                   <label>
//                     Services
//                     {/* <IoStar
//                       color="red"
//                       style={{ height: '6px', fontWeight: 'bold', marginBottom: '10px' }}
//                     /> */}
//                   </label>
//                   <div style={{ position: 'relative' }}>
//                     <input
//                       ref={el => {
//                         if (!inputRefs.current[index]) inputRefs.current[index] = {};
//                         inputRefs.current[index].serviceInput = el;
//                       }}
//                       type="text"
//                       className={`form-control ${!item.service ? 'border border-2' : ''}`}
//                       placeholder="Search service..."
//                       name="service"
//                       value={getServiceDisplayValue(item)}
//                       onChange={(e) => handleServiceInputChange(e, index)}
//                       autoComplete="off"
//                       style={{
//                         padding: '14px',
//                         border: '1px solid #dee2e6',
//                         outline: focusedInputs[index] === 'service' ? '2px solid #6174DD' : 'none',
//                         width: '100%',
//                         borderRadius: '4px'
//                       }}
//                       onFocus={() => handleInputFocus(index, 'service')}
//                       onBlur={() => handleInputBlur(index, 'service')}
//                     />
                    
//                     {serviceSuggested.length > 0 && focusedServiceIndex === index && (
//                       <MembershipServiceSuggestion
//                         data={serviceSuggested}
//                         handleServiceSuggestedClick={handleServiceSuggestedClick}
//                       />
//                     )}
//                   </div>
//                 </Grid>
//                 <Grid item xs={12} md={2}>
//                   <TextInputs
//                     inputRef={el => {
//                       if (!inputRefs.current[index]) inputRefs.current[index] = {};
//                       inputRefs.current[index].availableCountInput = el;
//                     }}
//                     title={'Count'}
//                     name={'availableCount'}
//                     value={item.availableCount === '' ? '' : item.availableCount}
//                     handleChange={(e) => handleServiceChange(e, index)}
//                     type={'number'}
//                     onFocus={() => handleInputFocus(index, 'availableCount')}
//                     onBlur={() => handleInputBlur(index, 'availableCount')}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center', marginTop: '25px' }}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     sx={{
//                       background: '#6174DD',
//                       width: '64px',
//                       fontSize: '12px',
//                       fontWeight: 'bold',
//                       marginRight: '10px',
//                       height: '40px'
//                     }}
//                     onClick={handleAddServiceRow}
//                   >
//                     Add
//                   </Button>
//                   {index !== 0 && (
//                     <Button
//                       variant="contained"
//                       color="error"
//                       sx={{
//                         background: '#ff0000',
//                         width: '64px',
//                         fontSize: '12px',
//                         fontWeight: 'bold',
//                         height: '40px',
//                         '&:hover': {
//                           background: '#ff6666',
//                         },
//                       }}
//                       onClick={() => handleRemoveServiceRow(index)}
//                     >
//                       Remove
//                     </Button>
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>
//           ))}
//         </DialogContent>
//         <DialogActions>
//           {loading ? <ShowLoader /> : (
//             <>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   sx={{
//                     background: '#6174DD',
//                   }}
//                   onClick={handleCloseDialogue}
//                 >
//                   Cancel
//                 </Button>
//               </div>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   sx={{
//                     background: '#6174DD',
//                   }}
//                   onClick={handleUpdateServiceTypeMembership}
//                 >
//                   Update
//                 </Button>
//               </div>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ServiceTypeFieldData;

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useNavigate } from 'react-router';
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { QurealCollection, useQurealActions } from "qureal-editor";
import {
  setLoading,
  setUpdatedServiceMembershipData,
  addServiceRow,
  removeServiceRow,
  updateServiceRow,
  setSelectedServiceMembership,
  resetUpdatedServiceMembershipData,
  removeMembershipFromState,
  updateMembershipInState
} from '../../redux/slices/membershipSlice';
import { useDispatch, useSelector } from 'react-redux';
import { IoStar } from 'react-icons/io5';
import MembershipServiceSuggestion from "./MembershipServiceSuggestion";
import { changeDateFormate } from 'src/utils/dateutils';
import SelectInputs from 'src/components/inputs/SelectInputs';
import BulkUploadMembershipDialog from "./components/BulkUploadMembershipDialog";
import { getHighlightedText } from 'src/utils/textUtils';


export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

const taxStatusOptions = [
  { value: 'withTax', label: 'Inclusive (5% GST)' },
  { value: 'withoutTax', label: 'Exclusive (5% GST)' },
  // { value: 'noGst', label: 'No GST' },
];  

const ServiceTypeFieldData = ({ data, state, branchData, services , search }) => {
  const membershipGridTemplate = '260px 150px 160px 150px 200px';  
  const membershipGridRowStyle = {
    display: 'grid',
    gridTemplateColumns: membershipGridTemplate,
    alignItems: 'center',
    columnGap: '10px',
  };
  const dispatch = useDispatch();
  const {
    updatedMembershipData,
    selectedMembershipId,
    loading
  } = useSelector((state) => state.memberships);

  const [openDialogue, setOpenDialogue] = useState(false);
  const [openEyeDialog, setOpenEyeDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedCardItem, setSelectedCardItem] = useState({});
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const { actionRef, download, share } = useQurealActions();
  const [serviceSuggested, setServiceSuggested] = useState([]);
  const [focusedServiceIndex, setFocusedServiceIndex] = useState(null);
  const [focusedInputs, setFocusedInputs] = useState({});
  const inputRefs = useRef([]);
  const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);

  const navigate = useNavigate();
  const { deleteMembership, activeBranchId, updateMembership, setShowMessage } = useMain();

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    dispatch(resetUpdatedServiceMembershipData());
    setServiceSuggested([]);
    setFocusedServiceIndex(null);
    setFocusedInputs({});
  };

  const taxableValue = useMemo(() => {
    const p = Number(updatedMembershipData?.membershipPrice) || 0;
    if (!isGstRequired) {
      return p.toFixed(2);
    }
    if (updatedMembershipData?.taxStatus === 'withTax') {
      return (p / 1.05).toFixed(2);
    }
    return p.toFixed(2);
  }, [updatedMembershipData?.membershipPrice, updatedMembershipData?.taxStatus , isGstRequired]);

  // const handleUpdate = (item) => {
  //   console.log(item,'item in SSSSSSSSS')
  //   dispatch(setSelectedServiceMembership(item));
  //   setOpenDialogue(true);
  // };
const handleUpdate = (item) => {
  console.log(item, 'item in SSSSSSSSS');

  // Clone the item to avoid direct mutation
  const dataToUpdate = { ...item };

  // Conditionally remove the redundant field
  if (item.duration) {
    delete dataToUpdate.validTill;
  } else if (item.validTill) {
    delete dataToUpdate.duration;
  }

  // Dispatch to slice (it will handle servicesOffered mapping)
  dispatch(setSelectedServiceMembership(dataToUpdate));
  setOpenDialogue(true);
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setUpdatedServiceMembershipData({ field: name, value }));
  };

  const handleServiceChange = (e, index) => {
    const { name, value } = e.target;

    // For availableCount field, handle empty string case
    let newValue = value;
    if (name === 'availableCount') {
      newValue = value === '' ? '' : Number(value);
    }
    dispatch(updateServiceRow({ index, field: name, value: newValue }));
  };

  const handleAddServiceRow = () => {
    dispatch(addServiceRow());
  };

  const handleRemoveServiceRow = (index) => {
    dispatch(removeServiceRow(index));
  };

 const handleUpdateServiceTypeMembership = async () => {
  try {
    dispatch(setLoading(true));

    const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);
    if (isGstRequired && (updatedMembershipData.taxStatus === 'noGst' || !updatedMembershipData.taxStatus)) {
      setShowMessage({
        message: 'Tax Status is required when GST number is present',
        messageType: 'error',
      });
      return;
    }

    // ✅ Validate that all services have been selected
    const hasEmptyService = updatedMembershipData.servicesOffered.some(
      (item) => !item.service || item.service === ''
    );

    if (hasEmptyService) {
      setShowMessage({
        message: 'Please select a service for all rows',
        messageType: 'error',
      });
      return;
    }

    // ✅ Prepare and clean the payload
    let preparedData = {
      ...updatedMembershipData,
      membershipPrice: Number(updatedMembershipData.membershipPrice),
      duration: Number(updatedMembershipData.duration),
      taxStatus: isGstRequired ? updatedMembershipData.taxStatus : 'noGst',
      taxableValue: taxableValue,
      servicesOffered: updatedMembershipData.servicesOffered.map((service) => ({
        service: service.service,
        availableCount:
          service.availableCount === '' ? 0 : Number(service.availableCount),
      })),
    };

    // ✅ Handle duration vs validTill logic (like discountType)
    if (preparedData.duration) {
      delete preparedData.validTill;
    } else if (preparedData.validTill) {
      delete preparedData.duration;
    }

    // ✅ API call
    const res = await updateMembership(
      selectedMembershipId,
      preparedData,
      `?branchId=${activeBranchId}`
    );

    if (res.statusCode === 200) {
      setShowMessage({
        message: res.message || 'Membership updated successfully',
        messageType: 'success',
      });

      // ✅ Update Redux state directly
      dispatch(
        updateMembershipInState({
          _id: selectedMembershipId,
          ...preparedData,
          membershipType: 'serviceType',
        })
      );

      handleCloseDialogue();
    } else {
      setShowMessage({
        message: res.message || 'Update Membership failed',
        messageType: 'error',
      });
    }
  } catch (error) {
    setShowMessage({
      message: error.message || 'Something went wrong',
      messageType: 'error',
    });
  } finally {
    dispatch(setLoading(false));
  }
};


  const handleDetails = (id) => {
    navigate(`/membershipdetail/${id}`, { state });
  };

  const handleEyeClick = (item) => {
    setSelectedCardItem(item);
    setOpenEyeDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenEyeDialog(false);
  };

  const handleDeleteField = (id) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    setDeleteLoading(true);
    try {
      const res = await deleteMembership(deleteId, `?branchId=${activeBranchId}`);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Membership deleted successfully',
          messageType: 'success',
        });

        dispatch(removeMembershipFromState(deleteId));
      } else {
        setShowMessage({
          message: res.message || 'Membership not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setOpenDeleteDialog(false);
      setDeleteId(null);
      setDeleteLoading(false);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  // Function to get service name by ID
  const getServiceNameById = (serviceId) => {
    const service = services.find(s => s._id === serviceId);
    return service ? service.serviceName : 'Unknown Service';
  };

  // Function to build content dynamically
  const buildContent = (services) => {
    return services?.map(serviceObj => {
      const serviceName = getServiceNameById(serviceObj.service?._id);
      return `✶ ${serviceName} (${serviceObj.availableCount} counts)`;
    }).join('<br>');
  };

  // Service input change handler
  const handleServiceInputChange = (e, index) => {
    const { value } = e.target;
    
    // Update the service name in Redux state
    dispatch(updateServiceRow({ index, field: 'serviceName', value: value }));
    dispatch(updateServiceRow({ index, field: 'service', value: '' }));
    
    updateServiceSuggested(value, index);
    setFocusedServiceIndex(index);
  };

  const updateServiceSuggested = (inputValue, index) => {
    if (inputValue === '') {
      setServiceSuggested([]);
      setFocusedServiceIndex(null);
    } else {
      const serviceSuggestions = services?.filter((service) =>
        service.serviceName.toLowerCase().includes(inputValue.toLowerCase())
      );
      setServiceSuggested(serviceSuggestions || []);
      setFocusedServiceIndex(index);
    }
  };

  const handleServiceSuggestedClick = (service) => {
    const index = focusedServiceIndex;
    if (index !== null) {
      // Update the service in Redux state
      dispatch(updateServiceRow({ index, field: 'service', value: service._id }));
      dispatch(updateServiceRow({ index, field: 'serviceName', value: service.serviceName }));
      setServiceSuggested([]);
      setFocusedServiceIndex(null);
      
      // Focus on the next input field (availableCount)
      setTimeout(() => {
        if (inputRefs.current[index] && inputRefs.current[index].availableCountInput) {
          inputRefs.current[index].availableCountInput.focus();
        }
      }, 100);
    }
  };

  const handleInputFocus = (index, fieldName) => {
    setFocusedInputs(prev => ({ ...prev, [index]: fieldName }));
  };

  const handleInputBlur = (index, fieldName) => {
    setFocusedInputs(prev => {
      const newState = { ...prev };
      delete newState[index];
      return newState;
    });
  };

  // Get display value for service input
  const getServiceDisplayValue = (item) => {
    return item.serviceName || (item.service ? getServiceNameById(item.service) : '');
  };

  

  const formatDurationDisplay = (item) => {
    if (item.duration) {
      return `${item.duration} Month${item.duration > 1 ? 's' : ''}`;
    } else if (item.validTill) {
      return changeDateFormate(item.validTill);
    }
    return 'N/A';
  };
  let discountPrefil = {
    discount_offer_with_body: {
      offer_name: selectedCardItem.membershipName,
      offer_price: `RS${selectedCardItem.membershipPrice}`,
      validity: `${
        selectedCardItem.duration
          ? `Valid for ${selectedCardItem.duration} Months`
          : `Valid till ${changeDateFormate(selectedCardItem.validTill)}`
      } `,
      content: buildContent(selectedCardItem?.servicesOffered),
      extra: '',
    },
  };
  if (selectedCardItem?.servicesOffered?.length > 20) {
    discountPrefil = {
      discount_offer_with_big_content: {
        offer_name: selectedCardItem.membershipName,
        offer_price: `RS${selectedCardItem.membershipPrice}`,
        validity: `Valid for ${selectedCardItem.duration} Months `,
        content: buildContent(selectedCardItem?.servicesOffered),
        extra: '',
      },
    };
  }
    return (
      <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
        <Snackbar
          open={errorMessage === '' ? false : true}
          autoHideDuration={6000}
          onClose={() => {
            setErrorMessage('');
          }}
          severity="error"
          message={errorMessage}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        />
        <BulkUploadMembershipDialog justifyContent="flex-end" services={services} />
        <table className="table-container mt-3" style={{ width: '100%' }}>
          <thead className="table-thead">
            <tr style={membershipGridRowStyle}>
              {['Membership Name', 'Membership Price', 'Validity', 'Rewards Points', 'Actions'].map(
                (h, index) => {
                  return (
                    <th key={index} style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                      {h}
                    </th>
                  );
                },
              )}
            </tr>
          </thead>
          <tbody className="table-tbody">
            {data.map((item) => {
             return (
                <tr key={item._id} style={membershipGridRowStyle}>
                <td style={{ textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {getHighlightedText(item?.membershipName, search)}
                </td>                  
                <td style={{ textAlign: 'center' }}>{item?.membershipPrice}</td>
                  <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{formatDurationDisplay(item)}</td>
                  <td style={{ textAlign: 'center' }}>{item?.rewardPointsOnPurchase}</td>
                  <td
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '4px',
                    }}
                  >
                    <IconButton
                      onClick={() => handleDetails(item._id)}
                      color="primary"
                      title="View Details"
                    >
                      <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
                    </IconButton>
                    <IconButton
                      onClick={() => handleUpdate(item)}
                      color="secondary"
                      title="Update"
                    >
                      <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                    </IconButton>
                    <IconButton
                      onClick={() => handleDeleteField(item._id)}
                      color="error"
                      title="Delete"
                    >
                      <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
                    </IconButton>
                    <IconButton onClick={() => handleEyeClick(item)} color="primary" title="View">
                      <FaEye color="black" style={{ fontSize: '1.2rem' }} />
                    </IconButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Card-Membership Dialog */}
        <Dialog
          open={openEyeDialog}
          onClose={handleCloseDialog}
          maxWidth={false}
          PaperProps={{
            style: {
              width: '1100px',
              height: '100vh',
              margin: 'auto',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: '10px',
              padding: '10px',
            },
          }}
        >
          <DialogContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              padding: '0',
              backgroundColor: 'white',
              overflow: 'hidden',
            }}
          >
            <QurealCollection
              collection_id={selectedCardItem?.servicesOffered?.length>20?"08e47f27-9311-4a55-a396-821b349a1507":"9ff9f448-3ce3-4d09-9bcc-4e5c4d763a9a"}
              organization="your_salon_QBdXA"
              background="white"
              style={{
                width: '100%',
                height: '100%',
                border: '1px solid black',
                borderRadius: '10px',
                overflow: 'hidden',
              }}
              actionRef={actionRef}
              preview={true}
              prefill={{
                // discount_offer_with_body: {
                //   offer_name: selectedCardItem.membershipName,
                //   offer_price: `RS${selectedCardItem.membershipPrice}`,
                //   validity: `Valid for ${selectedCardItem.duration} Months `,
                //   content: buildContent(selectedCardItem?.servicesOffered),
                //   extra: '',
                // },
                ...discountPrefil,
                ai_model: {
                  model: 'e9c8b5c4-4a2f-4c15-85a4-a57669a00999',
                },
                current_organization: {
                  name: branchData?.branchName,
                  primary_phone: branchData?.branchPhone,
                  primary_email: branchData?.branchEmail,
                  address: branchData?.address,
                  website: branchData?.branchName,
                  logo: {
                    value: branchData?.logo?.url,
                  },
                  logo_dark: {
                    value: branchData?.logo?.url,
                  },
                  logo_square: {
                    value: branchData?.logo?.url,
                  },
                },
              }}
            />
          </DialogContent>

          <DialogActions
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              padding: '16px',
              backgroundColor: '#f5f5f5',
            }}
          >
            <Button
              onClick={handleCloseDialog}
              color="primary"
              style={{
                marginRight: '10px',
              }}
            >
              Close
            </Button>

            <Button
              variant="contained"
              color="primary"
              sx={{
                background: '#6174DD',
                marginRight: '10px',
              }}
              onClick={share}
            >
              Share
            </Button>

            <Button
              variant="contained"
              color="primary"
              sx={{
                background: '#6174DD',
              }}
              onClick={download}
            >
              Download
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
          <DialogContent>Are you sure you want to delete this Membership?</DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={confirmDelete} color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* ServiceType membership details dialog */}
        <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md" fullWidth>
          <DialogTitle>ServiceType Membership Details</DialogTitle>
          <DialogContent>
            <DialogContentText>Here you can update membership details.</DialogContentText>
            <Box style={{ marginTop: '20px' }}>
              <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                  <TextInputs
                    title={'Membership Name'}
                    name={'membershipName'}
                    value={updatedMembershipData?.membershipName}
                    handleChange={handleInputChange}
                    type={'text'}
                  />
                </Grid>

                {!updatedMembershipData?.validTill && (
                  <Grid item xs={12} md={3}>
                    <TextInputs
                      required={false}
                      title={'Duration (in Months)'}
                      name={'duration'}
                      min={'0'}
                      value={updatedMembershipData?.duration}
                      handleChange={handleInputChange}
                      type={'number'}
                    />
                  </Grid>
                )}
                {!updatedMembershipData?.duration && (
                  <Grid item xs={12} md={3}>
                    <TextInputs
                      required={false}
                      title={'Valid Till'}
                      name={'validTill'}
                      value={updatedMembershipData?.validTill}
                      handleChange={handleInputChange}
                      type={'date'}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                )}

                {/* Membership Price now sits right next to Duration */}
                <Grid item xs={12} md={isGstRequired ? 6 : 3}>
                  <FormControl fullWidth>
                    <label style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      marginBottom: "8px",
                      display: "inline-block",
                      color: "#212529"
                    }}>Membership Price
                      <IoStar color='red' style={{ height: '6px', fontWeight: 'bold', marginLeft: '4px' }} />
                    </label>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        height: "57px",
                        transition: 'border-color 0.2s ease-in-out',
                        '&:hover': {
                          borderColor: '#6174DD',
                        },
                      }}
                    >
                      <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
                      <input
                        name="membershipPrice"
                        placeholder="0"
                        value={updatedMembershipData?.membershipPrice}
                        onChange={handleInputChange}
                        type="number"
                        min="0"
                        style={{
                          border: 'none',
                          outline: 'none',
                          flex: 1,
                          padding: '12px 0px',
                          fontSize: '16px',
                          background: 'transparent',
                          width: '100%'
                        }}
                      />
                      {isGstRequired && (
                        <Select
                          name="taxStatus"
                          value={updatedMembershipData?.taxStatus || 'noGst'}
                          onChange={handleInputChange}
                          displayEmpty
                          inputProps={{ 'aria-label': 'Without label' }}
                          sx={{
                            background: '#F0F0F0',
                            border: 'none',
                            height: '100%',
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            borderTopRightRadius: '3px',
                            borderBottomRightRadius: '3px',
                            '& .MuiSelect-select': {
                              padding: '8px 16px',
                              paddingRight: '24px !important',
                              height: '100% !important',
                              display: 'flex',
                              alignItems: 'center'
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              border: 'none'
                            },
                            '&:hover': {
                              background: '#e0e0e0',
                            },
                            '&.Mui-focused': {
                              background: '#e0e0e0',
                            },
                            borderLeft: '1px solid #ced4da'
                          }}
                        >
                          {taxStatusOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </Box>
                    {isGstRequired && (
                      <Box sx={{
                        p: '8px 12px',
                        backgroundColor: '#e9ecef',
                        border: '1px solid #ced4da',
                        borderTop: 'none',
                        borderRadius: '0 0 4px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                        <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
                      </Box>
                    )}
                  </FormControl>
                </Grid>

                {/* <Grid item xs={12} md={3}>
                  <TextInputs
                    title={'Reward Points'}
                    name={'rewardPointsOnPurchase'}
                    value={updatedMembershipData?.rewardPointsOnPurchase}
                    handleChange={handleInputChange}
                    type={'number'}
                  />
                </Grid> */}
              </Grid>
          </Box>

          <Box style={{ marginTop: '20px' }}>
            {updatedMembershipData.servicesOffered.map((item, index) => (
              <Box style={{ marginTop: '20px', position: 'relative' }} key={index}>
                <Grid container spacing={4} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <label>Services</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        ref={(el) => {
                          if (!inputRefs.current[index]) inputRefs.current[index] = {};
                          inputRefs.current[index].serviceInput = el;
                        }}
                        type="text"
                        className={`form-control ${!item.service ? 'border border-2' : ''}`}
                        placeholder="Search service..."
                        name="service"
                        value={getServiceDisplayValue(item)}
                        onChange={(e) => handleServiceInputChange(e, index)}
                        autoComplete="off"
                        style={{
                          padding: '14px',
                          border: '1px solid #dee2e6',
                          outline: focusedInputs[index] === 'service' ? '2px solid #6174DD' : 'none',
                          width: '100%',
                          borderRadius: '4px',
                        }}
                        onFocus={() => handleInputFocus(index, 'service')}
                        onBlur={() => handleInputBlur(index, 'service')}
                      />

                      {serviceSuggested.length > 0 && focusedServiceIndex === index && (
                        <MembershipServiceSuggestion
                          data={serviceSuggested}
                          handleServiceSuggestedClick={handleServiceSuggestedClick}
                        />
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextInputs
                      inputRef={(el) => {
                        if (!inputRefs.current[index]) inputRefs.current[index] = {};
                        inputRefs.current[index].availableCountInput = el;
                      }}
                      title={'Count'}
                      name={'availableCount'}
                      value={item.availableCount === '' ? '' : item.availableCount}
                      handleChange={(e) => handleServiceChange(e, index)}
                      type={'number'}
                      onFocus={() => handleInputFocus(index, 'availableCount')}
                      onBlur={() => handleInputBlur(index, 'availableCount')}
                    />
                  </Grid>

                  {/* Reward Points shown only on the first row */}
                  {index === 0 && (
                    <Grid item xs={12} md={2}>
                      <TextInputs
                        title={'Reward Points'}
                        name={'rewardPointsOnPurchase'}
                        value={updatedMembershipData?.rewardPointsOnPurchase}
                        handleChange={handleInputChange}
                        type={'number'}
                      />
                    </Grid>
                  )}

                  <Grid
                    item
                    xs={12}
                    md={index === 0 ? 4 : 6}
                    style={{ display: 'flex', alignItems: 'center', marginTop: '25px' }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        background: '#6174DD',
                        width: '64px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        marginRight: '10px',
                        height: '40px',
                      }}
                      onClick={handleAddServiceRow}
                    >
                      Add
                    </Button>
                    {index !== 0 && (
                      <Button
                        variant="contained"
                        color="error"
                        sx={{
                          background: '#ff0000',
                          width: '64px',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          height: '40px',
                          '&:hover': {
                            background: '#ff6666',
                          },
                        }}
                        onClick={() => handleRemoveServiceRow(index)}
                      >
                        Remove
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>
          </DialogContent>
          <DialogActions>
            {loading ? (
              <ShowLoader />
            ) : (
              <>
                <div style={{ width: '200px', margin: '3rem auto' }}>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    sx={{
                      background: '#6174DD',
                    }}
                    onClick={handleCloseDialogue}
                  >
                    Cancel
                  </Button>
                </div>
                <div style={{ width: '200px', margin: '3rem auto' }}>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    sx={{
                      background: '#6174DD',
                    }}
                    onClick={handleUpdateServiceTypeMembership}
                  >
                    Update
                  </Button>
                </div>
              </>
            )}
          </DialogActions>
        </Dialog>
      </Box>
    );
};

export default ServiceTypeFieldData;